import React from 'react';
import styled from 'styled-components';

export default function Button({text, icon}) {
    return (
        <StyledWrapper>
            <button className="button">
                <i className={`${icon} Icon`}/>
                <span>{`${text}`}</span>
            </button>
        </StyledWrapper>
    );
}

const StyledWrapper = styled.div`
.button {
    margin-left: 1rem;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    border: none;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.164);
    cursor: pointer;
    transition-duration: .5s;
    overflow: hidden;
    position: relative;
    background-color: #f2f3f5;
}

.Icon {
    fill: white;
    margin: 0;
    color: #45505b;
}

button span {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
}
button:hover span {
    position: static;
    width: auto;
    height: auto;
    overflow: visible;
    clip: auto;
    white-space: normal;
    display: flex;
    margin: 0;
    color: white;
}

.button:hover {
    width: 8rem;
    border-radius: 50px;
    background-color: #2353cc;
    align-items: center;
}

.button:hover .Icon {
    transform: translateX(-5%);
    color: white;
}

.button::before {
    position: absolute;
    top: -20px;
    color: white;
    transition-duration: .3s;
    font-size: 2px;
}

.button:hover::before {
    font-size: 13px;
    opacity: 1;
    transform: translateY(30px);
}
`;
